import type { Entitlement } from '@/types/Entitlement'

interface EntitlementCheckQueryKeyArgs {
  billingOrgId?: string
  entitlement: Entitlement
}

export const entitlementQueryKeys = {
  all: () => ['entitlements'] as const,
  check: (keyArgs: EntitlementCheckQueryKeyArgs) =>
    [
      'entitlements',
      'check',
      keyArgs.billingOrgId ?? '',
      keyArgs.entitlement,
    ] as const,
}
